<script>
  export let length = 3

  $: content = '⏳'
    .repeat(length)
    .split('')
    .reduce(function (str, char, i) {
      if (i % 3 !== 0) char += ' '
      return str + char
    }, '')
</script>

<span class="u-loading">{content}</span>
